import "../../index81.css";
import { jsx as a, jsxs as I, Fragment as y } from "react/jsx-runtime";
import { useRef as k, useEffect as p, useCallback as H } from "react";
import { ChevronUpLineIcon as m, ChevronDownLineIcon as C } from "@ifrc-go/icons";
import { _ as l } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import x from "../Button/index.js";
import R from "../../hooks/useBooleanState.js";
import j from "../../hooks/useTranslation.js";
import A from "../Container/index.js";
const L = "common", P = {
  expandableContainerCollapse: "Collapse",
  expandableContainerExpand: "Expand"
}, T = {
  namespace: L,
  strings: P
}, V = "_expandable-container_17290_1", D = "_header_17290_5", F = "_icon_17290_9", S = "_wiggle_17290_1", n = {
  expandableContainer: V,
  header: D,
  icon: F,
  wiggle: S
};
function X(h) {
  const {
    className: f,
    children: g,
    actions: u,
    initiallyExpanded: _ = !1,
    headerClassName: E,
    componentRef: t,
    childrenContainerClassName: b,
    onExpansionChange: i,
    withHeaderBorder: N,
    showExpandButtonAtBottom: w,
    ...v
  } = h, r = k(null), o = j(T), [
    e,
    {
      setValue: c,
      toggle: s
    }
  ] = R(!!_);
  p(() => {
    i && i(e);
  }, [e, i]), p(() => {
    t && (t.current = {
      setIsExpanded: c
    });
  }, [t, c]);
  const B = H(() => {
    var d;
    s(), r && ((d = r.current) == null || d.scrollIntoView());
  }, [s]);
  return /* @__PURE__ */ a(
    A,
    {
      ...v,
      containerRef: r,
      className: l(n.expandableContainer, f),
      headerClassName: l(n.header, E),
      childrenContainerClassName: l(n.content, b),
      withInternalPadding: !0,
      withHeaderBorder: N && e,
      withoutWrapInHeading: !0,
      actions: /* @__PURE__ */ I(y, { children: [
        u,
        /* @__PURE__ */ a(
          x,
          {
            variant: "tertiary",
            name: void 0,
            onClick: s,
            title: e ? o.expandableContainerCollapse : o.expandableContainerExpand,
            children: e ? /* @__PURE__ */ a(m, { className: n.icon }) : /* @__PURE__ */ a(C, { className: n.icon })
          }
        )
      ] }),
      actionsContainerClassName: n.actionsContainer,
      footerActions: w && e && /* @__PURE__ */ a(
        x,
        {
          variant: "tertiary",
          name: void 0,
          onClick: B,
          title: e ? o.expandableContainerCollapse : o.expandableContainerExpand,
          children: e ? /* @__PURE__ */ a(m, { className: n.icon }) : /* @__PURE__ */ a(C, { className: n.icon })
        }
      ),
      children: e && g
    }
  );
}
export {
  X as default
};
